// extracted by mini-css-extract-plugin
export default {"flash":"flash--tmgHx","center":"center--WRmbM"};